import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="DevOps">
                <h1>DevOps Consultancy Services</h1>
              </div>
              <p className="main_para">
                Utilize DevOps to transform your IT operations.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Accomplish your technical delivery objectives and create, deploy
                and test your products and solutions faster. Continuously
                improve operations through end-to-end DevOps consultancy.
              </p>
              <ul>
                <li>Faster product delivery and reduced time to market </li>
                <li>Risk mitigation and competitive advantage </li>
                <li>Accelerated workflow with efficient production </li>
                <li>Effective development and testing </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
